//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_list, venues_del, venues_changeState } from '@/apis/stadium'
import { sportType_list } from '@/apis/config'
export default {
    data() {
        return {
            config: {
                //運動類型
                motions: [],
            },
            form: {
                venueName: '',
                venueCode: '',
                sportTypeCode: '',
                status: '',
                areaCode: '',
            },
            //table loading
            loading: false,
            //table data
            data: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '場館編號', dataIndex: 'venueCode', key: 'venueCode', width: 240, },
            { title: '場館名稱', dataIndex: 'venueName', key: 'venueName', width: 330, },
            { title: '品牌名稱', dataIndex: 'mchName', key: 'mchName', width: 330, },     
            { title: '營業時間', dataIndex: 'businessHours', key: 'businessHours', width: 330, },                        
            { title: '場館類型', dataIndex: 'sportTags', key: 'sportTags', width: 220, scopedSlots: { customRender: 'sportTags' }, },
            { title: '場館評分', dataIndex: 'score', key: 'score', width: 220, scopedSlots: { customRender: 'score' }, },
            { title: '熱門場館', dataIndex: 'isPopular', key: 'isPopular', width: 100, scopedSlots: { customRender: 'isPopular' }, },
            { title: '推薦場館', dataIndex: 'isFeatured', key: 'isFeatured', width: 100, scopedSlots: { customRender: 'isFeatured' }, },
            { title: '場館狀態', dataIndex: 'status', key: 'status', width: 100, scopedSlots: { customRender: 'status' }, },
            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageConfig() {
            try {
                //加載運動類型
                const params = { typeCode: '', name: '', pageSize: 99, pageNumber: 1 };
                const res = await sportType_list(params);
                this.config.motions = res.data.records;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await venues_list({
                    ...this.form,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.data = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getSportTypeName(sportTags) {
            if (sportTags) {
                return sportTags.join(',');
            }
            return ''
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await venues_del(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/gymnasium/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/gymnasium/form/${id}`);
            } else {
                this.$router.push('/gymnasium/form');
            }

        }
    }
}
